module.exports = __webpack_public_path__ + "static/media/p_20_0.3a9ac5c2.png";